import { signal } from '@angular/core';
import { UserPermissionsService } from '../services/user-permissions.service';

/**
 * Permission configuration interface.
 * Defines the structure for each permission check.
 */
export interface PermissionConfig {
  /** Descriptive name for the permission */
  description: string;
  /** List of roles that should have this permission */
  roles: string[];
  /** List of modules to check permission against */
  modules: string[];
  /** Reference to the permission signal in UserPermissionsService */
  signalGetter: (service: UserPermissionsService) => ReturnType<typeof signal<boolean>>;
}

/**
 * Centralized permission configuration.
 * Add new permissions here instead of modifying auth.guard.ts
 */
export const PERMISSIONS_CONFIG: PermissionConfig[] = [
  {
    description: 'Legal Entity List status dropdown permission',
    roles: ['BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasStatusDropdownPermission,
  },
  {
    description: 'Legal Entity Documents upload permission (Replace File button)',
    roles: ['BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasUploadDocumentPermission,
  },
  {
    description: 'Entity Identification edit permission',
    roles: ['BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasEditEntityIdentificationPermission,
  },
  {
    description: 'Contact Information edit/add permission',
    roles: ['BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasEditContactInformationPermission,
  },
  {
    description: 'B&CS Assessment document upload permission',
    roles: ['BCR - BCS Team Member', 'BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasUploadBncsDocumentPermission,
  },
  {
    description: 'Document Repository Replace File button permission',
    roles: ['BCR - PST member', 'BCR - Privacy Office team member'],
    modules: ['Document Repository'],
    signalGetter: (service) => service.hasDocumentRepositoryUploadPermission,
  },
  {
    description: 'PST member role for editing DDQ-Specific Fields',
    roles: ['BCR - PST member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasPstMemberRole,
  },
  {
    description: 'DDQ Nominee role for viewing DDQ File upload',
    roles: ['BCR - DDQ Nominee'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasDdqNomineeRole,
  },
  {
    description: 'Privacy Office role for DDQ approval/rejection at status 12',
    roles: ['BCR - Privacy Office team member'],
    modules: ['Legal Entity List'],
    signalGetter: (service) => service.hasPrivacyOfficeRole,
  },
];
